module.exports = __webpack_public_path__ + "static/img/10.7918de2.png";


//////////////////
// WEBPACK FOOTER
// ./static/images/products/1/2/1/sp/10.png
// module id = 8If+
// module chunks = 0